import React, { FC } from "react";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { Input } from "antd";
import { useAppDispatch, useAppSelector } from "../../redux/hooks.ts";
import { setSearchText } from "../../redux/slices/searchSlice.ts";
import { onFilterFolders } from "../../utils/folders/filters.ts";

export const Searchbar: FC = () => {
  const dispatch = useAppDispatch();

  const { filterChoice, sortingChoice, filterDates, filterUser } =
    useAppSelector((state) => state.folder);
  const searchText = useAppSelector((state) => state.search.text);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setSearchText(e.target.value));
  };

  const handleKeyDown = async (e: React.KeyboardEvent<HTMLInputElement>) => {
    const search = e.currentTarget.value.toLowerCase();

    if (e.key === "Enter") {
      await onFilterFolders(
        filterChoice,
        sortingChoice,
        filterDates,
        filterUser,
        search,
        dispatch,
      );
    }
  };

  return (
    <div className="w-full mr-8 flex items-center">
      <MagnifyingGlassIcon className="h-5 w-5 text-blue-gray-400 mr-2" />
      <Input
        placeholder="Buscar..."
        variant="borderless"
        className="outline-none p-2"
        onChange={handleSearchChange}
        onKeyDown={handleKeyDown}
        value={searchText}
      />
    </div>
  );
};
